import { useMutation } from 'react-query';

import { useRequest, type MutationFunction } from '../common';

export type UseBulkCreateDiscountsVars = {
  quoteId: number;
  deleteExistingDiscounts: boolean;
  discounts: Array<{
    discountDefId?: number;
    manualPercentage?: number;
    name: string;
  }>;
  components: number[];
};

export type UseBulkCreateDiscountsData = Array<{
  id: number;
  quantities: unknown[];
  discounts: unknown[];
  discountCells: unknown[];
}>;

export const useBulkCreateDiscounts: MutationFunction<
  UseBulkCreateDiscountsData,
  UseBulkCreateDiscountsVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/bulk_create_discounts`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    queryOptions,
  );
};
